import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client';
import { IApplicationFileDTO } from '@common-frontend-submodule/interfaces/application-file/iapplication-file.interface';
import { IApplicationFileCreationDTO } from '@common-frontend-submodule/interfaces/application-file/iapplication-file-creation.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { ApplicationFileRoutes } from '@common-frontend-submodule/enums/routes/application-file-routes.enum';

const apiClient = ApiClient.getInstance()

interface ApplicationFileContextProps {
  getById: (applicationFileId: string) => Promise<IApiResponseGenericDTO<IApplicationFileDTO>>;
  getAll: (applicationId: string) => Promise<IApiResponseGenericDTO<IApplicationFileDTO[]>>;
  delete: (applicationFileId: string) => Promise<IApiResponseGenericDTO<boolean>>;
  create: (file: File, model: IApplicationFileCreationDTO) => Promise<IApiResponseGenericDTO<IApplicationFileDTO>>;
}

const ApplicationFileContext = createContext<ApplicationFileContextProps | undefined>(undefined);

export const ApplicationFileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (applicationFileId: string): Promise<IApiResponseGenericDTO<IApplicationFileDTO>> => {
    return await apiClient.getRequest<IApplicationFileDTO>(`${ApplicationFileRoutes.BasePrefix}/${applicationFileId}`);
  };

  const getAll = async (applicationId: string): Promise<IApiResponseGenericDTO<IApplicationFileDTO[]>> => {
    return await apiClient.getRequest<IApplicationFileDTO[]>(`${ApplicationFileRoutes.BasePrefix}/all/${applicationId}`);
  };

  const create = async (file: File, model: IApplicationFileCreationDTO): Promise<IApiResponseGenericDTO<IApplicationFileDTO>> => {
    const formData = new FormData();

    formData.append('file', file);

    Object.entries(model).forEach(([key, value]) => {
      formData.append(key, value as string); // Преобразуем значение в строку
    });
  
    return await apiClient.postFormDataRequest<FormData, IApplicationFileDTO>(
        ApplicationFileRoutes.BasePrefix,
      formData,
    );
  };

  const deleteApplicationFile = async (applicationFileId: string): Promise<IApiResponseGenericDTO<boolean>> => {
    return await apiClient.deleteRequest<null, boolean>(`${ApplicationFileRoutes.BasePrefix}/${applicationFileId}`);
  };

  return (
    <ApplicationFileContext.Provider value={{ getById, getAll, create, delete: deleteApplicationFile }}>
      {children}
    </ApplicationFileContext.Provider>
  );
};

export const useApplicationFileStore = () => {
  const context = useContext(ApplicationFileContext);
  if (!context) {
    throw new Error('useApplicationFileStore must be used within a ApplicationFiletProvider');
  }
  return context;
};
